import ReactGA from 'react-ga4';
import { API } from 'aws-amplify';
import { graphqlOperation, GraphQLResult } from '@aws-amplify/api-graphql';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { User, UserBackend } from './users.interfaces';
import { userDeleteQuery } from './userDelete.query';

export const deleteUserThunk = createAsyncThunk(
  'user/deleteUser',
  async (
    payload: {
      id: string;
    },
    thunkApi,
  ): Promise<any> => {
    const { id } = payload;

    try {
      const result = (await API.graphql(
        graphqlOperation(userDeleteQuery, { input: { id } }),
      )) as GraphQLResult<{ deleteUser: User }>;
      ReactGA.event({
        category: 'Team',
        action: 'Delete',
      });
      return undefined;
    } catch (error) {
      return thunkApi.rejectWithValue({
        message: error,
      });
    }
  },
);
